import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  UtilsModule,
  FormValidationModule,
} from '@tablesready/common-ui';
import { AddEditLocationComponent } from './add-edit-location/add-edit-location.component';
import { Angulartics2Module } from 'angulartics2';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { FrontendGooglePlacesModule } from '@tablesready/frontend-google-places';

@NgModule({
  declarations: [AddEditLocationComponent],
  imports: [
    FrontendIconsModule,
    FormsModule,
    CommonModule,
    UtilsModule,
    FrontendGooglePlacesModule,
    ReactiveFormsModule,
    FormValidationModule,
    Angulartics2Module,
    FrontendDropdownModule,
    FrontendModalModule,
  ],
  exports: [AddEditLocationComponent],
})
export class ModalsModule {}
